import React from 'react';
import { ArticleHero } from '../components/ArticleHero';
import { HeroImage } from '../components/HeroImage';
import { ArticleSectionBlocks } from '../components/ArticleSectionBlocks';
import { VehicleTable } from '../components/VehicleTable';
import { DocumentsSidebar } from '../components/DocumentsSidebar';
import { CourtDocuments } from '../components/CourtDocuments';
import { SourceNote } from '../components/SourceNote';
import { articleSections, articleSectionsAfterVehicles } from '../data/article';
export function Article() {
  return <main data-id="element-98" data-mp="tw2xc376kv53">
      <article className="mx-auto max-w-shell px-5 pt-10 sm:px-8 sm:pt-14" data-id="element-99" data-mp="txe0c0ssxyv5">
        <div className="max-w-[820px]" data-id="element-100" data-mp="p300nm73x5ko">
          <ArticleHero data-id="element-101" data-mp="k5hozo1pgc8z" />
          <HeroImage data-id="element-102" data-mp="k69mj4ev4k1w" />
        </div>

        <div className="mt-12 grid gap-x-16 gap-y-14 lg:grid-cols-[minmax(0,1fr)_260px]" data-id="element-103" data-mp="k4ygsz1ux285">
          <div className="max-w-read" data-id="element-104" data-mp="1hmf25574qbrg">
            <ArticleSectionBlocks sections={articleSections} data-id="element-105" data-mp="1cu5g4094xvug" />
            <VehicleTable data-id="element-106" data-mp="1cskoaie7gr0a" />
            <ArticleSectionBlocks sections={articleSectionsAfterVehicles} data-id="element-107" data-mp="1csasge6hbpmo" />
            <SourceNote data-id="element-108" data-mp="1gtzoy5gmw2xj" />
          </div>

          <DocumentsSidebar data-id="element-109" data-mp="1ls16un2bpw7f" />
        </div>

        <div className="max-w-[820px]" data-id="element-110" data-mp="1lrsucwa44swr">
          <CourtDocuments data-id="element-111" data-mp="180w4hd7kmpte" />
        </div>
      </article>
    </main>;
}